"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSignedUrl = getSignedUrl;
exports.getSourcesSignedUrl = getSourcesSignedUrl;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _Sources = require("@studio/constants/Sources");
var _checkSourceTypes = require("./checkSourceTypes");
var _getSources = require("./getSources");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var sourcesSignedUrlCache = {
  lastUpdated: new Date().getTime()
};

/**
    Returns a single source with signed url
    @param {{}} source
    @param {{}} apiClient
    @param {{}} forceFetch - Force fetch the signed URL by skipping cache
    @returns {{}} source with signed url.
   */
function getSignedUrl(_x, _x2) {
  return _getSignedUrl.apply(this, arguments);
}
/**
    Maps a list of sources to signed urls
    @param {[]} sources
    @param {{}} apiClient
    @param {string} teamId
    @param {string} eventId
   */
function _getSignedUrl() {
  _getSignedUrl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(source, apiClient) {
    var _source$value;
    var forceFetch,
      value,
      eventDocId,
      signedUrl,
      _yield$apiClient$even,
      url,
      _args = arguments;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          forceFetch = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
          if (!(!(source !== null && source !== void 0 && source.value) || (0, _checkSourceTypes.isPresenterSource)(source) || (source === null || source === void 0 || (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.type) === _Sources.STOCK_MEDIA)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", source);
        case 1:
          value = (0, _getSources.getMediaSourceValueObject)(source.value);
          eventDocId = value.eventDocId;
          signedUrl = sourcesSignedUrlCache[eventDocId];
          if (!((!signedUrl || forceFetch) && source.team && source.event)) {
            _context.next = 3;
            break;
          }
          _context.next = 2;
          return apiClient.eventDoc.getSignedUrl(source.team, source.event, eventDocId);
        case 2:
          _yield$apiClient$even = _context.sent;
          url = _yield$apiClient$even.url;
          signedUrl = url;
          sourcesSignedUrlCache[eventDocId] = url;
        case 3:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, source), {}, {
            value: _objectSpread(_objectSpread({}, value), {}, {
              url: signedUrl
            })
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getSignedUrl.apply(this, arguments);
}
function getSourcesSignedUrl(_x3, _x4, _x5, _x6) {
  return _getSourcesSignedUrl.apply(this, arguments);
}
function _getSourcesSignedUrl() {
  _getSourcesSignedUrl = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(sources, apiClient, teamId, eventId) {
    var minutes, isValidCache, eventDocIds, _yield$apiClient$even2, urls, sourcesWithSignedUrls;
    return _regenerator["default"].wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          minutes = (0, _utils.getMinutesDifference)(sourcesSignedUrlCache.lastUpdated, new Date().getTime());
          isValidCache = minutes < _Sources.SIGNED_URLS_CACHE_TIMEOUT_VALUE;
          eventDocIds = sources === null || sources === void 0 ? void 0 : sources.reduce(function (accumulator, source) {
            var value = source.value,
              type = source.type;
            if (!_Sources.S3SourceTypes.includes(type)) {
              return accumulator;
            }
            var _getMediaSourceValueO = (0, _getSources.getMediaSourceValueObject)(value),
              eventDocId = _getMediaSourceValueO.eventDocId;
            if (!eventDocId || (value === null || value === void 0 ? void 0 : value.type) === _Sources.STOCK_MEDIA) {
              return accumulator;
            }
            var signedUrl = sourcesSignedUrlCache[eventDocId];
            if (signedUrl && isValidCache) {
              return accumulator;
            }
            accumulator.push(eventDocId);
            return accumulator;
          }, []);
          if (!(eventDocIds !== null && eventDocIds !== void 0 && eventDocIds.length)) {
            _context2.next = 2;
            break;
          }
          _context2.next = 1;
          return apiClient.eventDoc.getSignedUrls(teamId, eventId, {
            eventDocs: eventDocIds
          });
        case 1:
          _yield$apiClient$even2 = _context2.sent;
          urls = _yield$apiClient$even2.urls;
          // update sourcesSignedUrlCache including last updated timestamp.
          sourcesSignedUrlCache = _objectSpread(_objectSpread(_objectSpread({}, sourcesSignedUrlCache), urls), {}, {
            lastUpdated: new Date().getTime()
          });
        case 2:
          sourcesWithSignedUrls = sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
            var value = source.value,
              type = source.type;
            if (!_Sources.S3SourceTypes.includes(type)) {
              return source;
            }

            // Convert to source object for legacy media files which has value as string
            var valueObj = (0, _getSources.getMediaSourceValueObject)(value);
            var eventDocId = valueObj.eventDocId;
            if (!eventDocId || (value === null || value === void 0 ? void 0 : value.type) === _Sources.STOCK_MEDIA) {
              return source;
            }
            var signedUrl = sourcesSignedUrlCache[eventDocId];
            return _objectSpread(_objectSpread({}, source), {}, {
              value: _objectSpread(_objectSpread({}, valueObj), {}, {
                url: signedUrl
              })
            });
          });
          return _context2.abrupt("return", sourcesWithSignedUrls);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getSourcesSignedUrl.apply(this, arguments);
}